import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './LiveAvailableShiftsActionType';
import * as actions from './LiveAvailableShiftsActions';
import * as services from './LiveAvailableShiftsServices';
import { SweetAlert } from '../../../components/sweetalert/SweetAlert.js';


function* fetchLiveAvailableShiftsSaga(action) {
    try {
        const response = yield call(services.getLiveAvailableShiftsWithPagination, action.payload);
        yield put(actions.fetchLiveAvailableShiftsSuccess(response));
    } catch (error) {
        yield put(actions.fetchLiveAvailableShiftsFailure(error.message));
        SweetAlert.error({
            title: 'Error!',
            text: 'Failed to fetch Live Available Shifts data',
            showConfirmButton: true
        });
    }
}

function* fetchLegendTableDataSaga() {
    try {
        const response = yield call(services.fetchLegendTableData,);

        if (response?.success) {
            yield put(actions.fetchLegendTableDataSuccess(response));
        } else {
            yield put(actions.fetchLegendTableDataFailure('Failed to fetch legend data'));

            SweetAlert.error({
                title: 'Error!',
                text: response?.errorMessage
            });
        }
    } catch (error) {
        console.error('Fetch Legend Data Error:', error);

        yield put(actions.fetchLegendTableDataFailure(error?.message || 'Failed to fetch legend data'));

        SweetAlert.error({
            title: 'Error!',
            text: error?.message || 'Failed to fetch legend data.'
        });
    }
}


function* watchLiveAvailableShiftsSaga() {
    yield takeLatest(types.FETCH_LIVE_AVAILABLE_SHIFTS_REQUEST, fetchLiveAvailableShiftsSaga);
    yield takeLatest(types.FETCH_LEGEND_TABLE_DATA_REQUEST, fetchLegendTableDataSaga);
}

export default watchLiveAvailableShiftsSaga;